import { Label } from 'src/app/models/label.model';

export class LoadLabels {
  static readonly type = '[Labels List] Load Labels';
  constructor(public langIso: string) {}
}

export class LoadLabelsSuccess {
  static readonly type = '[Labels Effect] Load Labels Success';
  constructor(public labelsList: Label[]) {}
}
